import { $ABTest } from '@lemon8/webapp-shared/model';
import { $IsMobileUser } from '~/utils/is-mobile-user';
import { Atom, atom } from 'jotai';
import _get from 'lodash/get';

/**
 * 0: control group
 * 1: use article carousel
 * 2: opt article interception
 */
export const $SEOReflowV42: Atom<number> = atom((get) => {
  const { parameters } = get($ABTest);
  if (__BUILD_TYPE__ === 'local_dev') {
    return 0;
  }
  return _get(parameters, ['seo_web', 'lemon8.seo_cta_v42'], 0);
});

export const $SEOReflowV42ArticleCarousel: Atom<boolean> = atom((get) => {
  const isMobileUser = get($IsMobileUser);
  const V42Config = get($SEOReflowV42);
  return isMobileUser && V42Config === 1;
});

export const $SEOReflowV42InterceptOpt: Atom<boolean> = atom((get) => {
  const isMobileUser = get($IsMobileUser);
  const V42Config = get($SEOReflowV42);
  return isMobileUser && V42Config === 2;
});

/**
 * 0: control group
 * Article:
 *  1 means allow content unfolded and display anchors while being folded
 *  2 means disallow content unfolded and display anchors while being folded
 *  3 means allow content unfolded and hide anchors while being folded
 * Video:
 *  1 means display with fixed download banner
 *  2 means play video manually
 *  3 means 1 + 2
 */
export const $SEOReflowV4: Atom<number> = atom((get) => {
  const { parameters } = get($ABTest);
  if (__BUILD_TYPE__ === 'local_dev') {
    return 2;
  }
  return _get(parameters, ['seo_web', 'lemon8.seo_reflow_v4'], 2);
});

export const $HitSEOReflowV4: Atom<boolean> = atom((get) => {
  const isMobileUser = get($IsMobileUser);
  const V4Config = get($SEOReflowV4);
  return isMobileUser && V4Config !== 0;
});

/**
 * Article: 1 or 3 means folded content can be expanded after click
 * Video: 1 or 3 means display with fixed download banner
 */
export const $SEOReflowV4AllowExpand: Atom<boolean> = atom((get) => {
  const isMobileUser = get($IsMobileUser);
  const V4Config = get($SEOReflowV4);
  return isMobileUser && (V4Config === 1 || V4Config === 3);
});

/**
 * Article: 2 or 3 has no common features, thus this combination means nothing
 * Video: 2 or 3 means video should be played manually
 */
export const $SEOReflowV4ManualPlay: Atom<boolean> = atom((get) => {
  const isMobileUser = get($IsMobileUser);
  const V4Config = get($SEOReflowV4);
  return isMobileUser && (V4Config === 2 || V4Config === 3);
});

// hit 1st test group
export const $SEOReflowV4AllowExpandFoldWithAnchor: Atom<boolean> = atom((get) => {
  const isMobileUser = get($IsMobileUser);
  const V4Config = get($SEOReflowV4);
  return isMobileUser && V4Config === 1;
});

// hit 2nd test group
export const $SEOReflowV4NeverExpandFoldWithAnchor: Atom<boolean> = atom((get) => {
  const isMobileUser = get($IsMobileUser);
  const V4Config = get($SEOReflowV4);
  return isMobileUser && V4Config === 2;
});

// hit 3rd test group
export const $SEOReflowV4AllowExpandFoldWithoutAnchor: Atom<boolean> = atom((get) => {
  const isMobileUser = get($IsMobileUser);
  const V4Config = get($SEOReflowV4);
  return isMobileUser && V4Config === 3;
});
